
<template>
    <v-container fluid grid-list-xl class="login-container">
        <v-layout  row wrap>
            <v-flex lg3 md4 sm12 class="login-section">
                <div class="logo-language-selection">
                    <img v-if="logo" v-bind:src="logo" alt="smass logo"  class="logo">
                    <SettingsMenu
                        :nudge-width="280"
                        :nudge-left="270"
                        :nudge-top="-20"
                        :show-switches="false"/>
                </div>

                <div class="login-form">
                    <v-toolbar flat dense>
                        <v-toolbar-title class="font-size-big no-margin-left color-headings-text font-weight-bold">{{text('db.global.TYPE_GTS_LOGIN_TITLE')}}</v-toolbar-title>
                    </v-toolbar>

                    <div class=" pb-2">
                        <v-form ref="loginForm" v-model="valid" class="margin-bottom-xl">

                            <div class="error" v-html="error"></div>

                            <div class="login-input-field">
                                <username-icon class="username_icon"/>
                                <v-text-field
                                    class="text-field"
                                    type="text"
                                    name="username"
                                    :placeholder="text('api.login.username')"
                                    v-model="username"
                                    :rules="nameRules"
                                    @keyup.enter="login"
                                    @input="handleLoginInputsChange"
                                ></v-text-field>
                            </div>

                            <div class="login-input-field">
                                <password-icon class="password_icon"/>
                                <v-text-field
                                    type="password"
                                    name="password"
                                    :placeholder="text('api.login.password')"
                                    v-model="password"
                                    :rules="passwordRules"
                                    @keyup.enter="login"
                                    @input="handleLoginInputsChange"
                                ></v-text-field>
                            </div>

                            <v-btn block @click="login" class="login-btn" :disabled="!valid" color="primary" >{{text('api.login.button')}}</v-btn>
                        </v-form>
                        <div class="color-body">

                        <span v-if="getSelfRegistrationEnabled"  class="font-weight-light">{{text('api.pro.loginPage.noAccount')}}</span>
                            <span class="float-right">
                                <router-link :to="'/forgot-password'" class="color-headings-text">{{text('api.login.forgot.password')}}</router-link>
                            </span><br />
                            <span v-if="getSelfRegistrationEnabled">
                                <router-link :to="'/user-registration'" class="color-primary">{{text('api.login.new.account')}}</router-link>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="powered-by">
                    <span class="color-body font-weight-light">{{text('db.global.TYPE_GTS_COMMERCIAL_FIELD_TITLE')}} </span>
                    <in4-medicine-logo class="margin-left-xxs"></in4-medicine-logo>
                    <br />
                    <doc-dropdown
                        :bottom="false"
                        :nudge-top="40"
                        :activator-btn-class="'login-page-btn-menu'"
                        :doc-code-list="docCodeList">
                        <router-link
                            :slot="['dropdown-btn', code].join('-')"
                            :to="{name: 'DocPage', query: {type: code}}"
                            :key="code"
                            v-for="code in docCodeList"
                            :class="{
                            'doc-dropdown-btn': docCodeList.length !== 1,
                            'login-page-btn-menu': true,
                            }"
                        >
                            {{text("api.doc.pro." + code)}}
                        </router-link>
                    </doc-dropdown>
                </div>
            </v-flex>

            <v-flex md8 lg9 class="hidden-sm-and-down" >
                <v-carousel hide-controls >

                    <v-carousel-item src="static/img/login_bg.jpg" transition="fade"
                                      reverse-transition="fade">
                        <h4>{{text('db.global.TYPE_GTS_HOME_TITLE_A')}}</h4>
                        <span v-html="text('db.global.TYPE_GTR_PAGE_HOME_TEXTFIELD_1')"></span>
                    </v-carousel-item>

                    <v-carousel-item src="static/img/login_bg.jpg" transition="fade"
                                     reverse-transition="fade">
                        <h4>{{text('db.global.TYPE_GTS_HOME_TITLE_B')}}</h4>
                        <span v-html="text('db.global.TYPE_GTR_PAGE_HOME_TEXTFIELD_2')"></span>
                    </v-carousel-item>

                </v-carousel>
            </v-flex>
        </v-layout>

        <div class="cookies-display">
            <detect-browser-cookie></detect-browser-cookie>
            <accept-cookie></accept-cookie>
        </div>
    </v-container>

</template>

<!-- ################################################################## -->

<script>
    import {mapGetters} from 'vuex';
    import AcceptCookie from '../../../professional/components/cookies/AcceptCookie';
    import DetectBrowserCookie from '../../../common/components/cookies/DetectBrowserCookie';
    import Vue from "vue";
    import DocDropdown from "../shared/DocDropdown";
    import In4MedicineLogo from "../svg/shared/in4MedicineLogo";
    import SettingsMenu from "../shared/SettingsMenu";
    import UsernameIcon from "../svg/shared/usernameIcon";
    import PasswordIcon from "../svg/shared/passwordIcon";
    import * as Bowser from "bowser";


    export default {
        name: 'LoginPage',
        components: {
            PasswordIcon,
            UsernameIcon,
            SettingsMenu,
            In4MedicineLogo,
            DocDropdown,
//            HeaderBar
            AcceptCookie,
            DetectBrowserCookie
        },
        data() {
            return {
                /* username: '',
                password: '',*/
                error: null,
                valid: true,
                username: '',
                nameRules: [
                    (v) => !!v ||  this.text("api.login.username") + ' ' + this.text("api.error.isRequired"),
                    (v) => v && v.length <= 128 || 'Name must be less than 128 characters'
                ],
                password: '',
                passwordRules: [
                    (v) => !!v ||  this.text("api.login.password") + ' '  + this.text("api.error.isRequired"),
                    (v) =>  v && v.length >= 1 || 'Password must be valid'
                ],
                arrowDownPlugin: Vue.ArrowDown.arrowDownSvg
            }
        },
        computed: {
            ...mapGetters({
                languageList: 'TranslationStore/getLanguageList',
                logo: 'TranslationStore/getLogo',
                getAppTypes: 'UserStore/getAppTypes',
                getCurrentAppType: 'UserStore/getCurrentAppType',
                getSelfRegistrationEnabled: 'TranslationStore/getSelfRegistrationEnabled',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getDocCodeList: 'TranslationStore/getDocCodeList',
                getDocApplicationType: 'TranslationStore/getDocApplicationType',
                getTheme: 'ThemeStore/getTheme'
            }),

            languageListForDropdown () {

                let langsForDropdown = [];
                this.languageList.forEach((langKey) => {
                    langsForDropdown.push({
                        key: langKey,
                        name: this.text("api.language.name."+langKey)
                    });
                });
                return langsForDropdown;
            },

            selectedLang: {
                get () {
                    return this.$store.state["TranslationStore"].selectedLanguage;
                },
                set (newVal) {
                    this.$store.commit('TranslationStore/setSelectedLanguage', newVal);
                }
            },

            docCodeList() {
                const applicationType = this.getDocApplicationType();

                return this.getDocCodeList(applicationType);
            }
        },

        mounted: function () {
            this.$nextTick(function () {

                // In Chrome, when trying to get the value of an autofilled input before any user interaction, that value will be empty.
                // So we need a workaround to fix this behavior.
                setTimeout(() => {
                    try {
                        if (!!document.querySelector('input[name="username"]:-webkit-autofill') && !!document.querySelector('input[name="password"]:-webkit-autofill')) {
                            // Username and password autocompleted, so enable "Login" button.
                            this.valid = true;
                        }
                    }
                    catch (err) {
                        // Do nothing. This try/catch is here because ":-webkit-autofill" selector only works in Google Chrome,
                        // but throws an error in Firefox. This way, we prevent that Firefox error.
                    }
                }, 100);
            });

            let selectedInputIcon = document.getElementsByClassName('language-option');
            if (selectedInputIcon.length !== 0) {
                let selectLanguage = selectedInputIcon[0].getElementsByClassName('input-group__append-icon');
                selectLanguage[0].innerHTML = this.arrowDownPlugin();
            }

        },

        methods: {

            handleLoginInputsChange() {
                this.error = "";
            },

            login() {
                if (this.$refs.loginForm.validate()) {
                    this.error = "";
                    let promiseLogin = this.$store.dispatch("UserStore/submitLogin", {
                        username: this.username,
                        password: this.password,
                    });

                    promiseLogin.then((response) => {

                        // Set user-specific APPLICATION_TYPE.
                        if (typeof response.data.appProperties !== "undefined"
                                && typeof response.data.appProperties.APPLICATION_TYPE !== "undefined") {
                            this.$store.commit("UserStore/setCurrentAppType", response.data.appProperties.APPLICATION_TYPE, {root: true});
                        }

                        // This will tell if Patient Profile panel (on Assessment Start page) must be hidden.
                        // Only need to set to sessionStorage with "false" value (if we need to hide Patient Profile panel), in all the other cases it will be shown by default.
                        if (typeof this.mustShowPatientPanel !== "undefined" && this.mustShowPatientPanel.trim() == "false"){
                            sessionStorage.setItem('must-show-patient-panel', false);
                        }
                        else {
                            sessionStorage.removeItem('must-show-patient-panel');
                        }

                        // --- "token" param ---
                        if (window.location.search.length > 0 && window.location.search.indexOf("?token=") !== -1) {
                            let tokenUrlParam = window.location.search;
                            window.location.replace(window.location.origin + window.location.pathname + "#/summary" + tokenUrlParam);
                        }
                        // --- "msitat" param ---
                        else if (window.location.search.indexOf("?msitat=") !== -1 || window.location.search.indexOf("&msitat=") !== -1) {
                            if (window.location.search.indexOf("?assessment=") !== -1 || window.location.search.indexOf("&assessment=") !== -1) {
                                window.location.replace(window.location.origin + window.location.pathname + "#/summary" + window.location.search);
                            }
                            else {
                                window.location.replace(window.location.origin + window.location.pathname + "#/assessment-list" + window.location.search);
                            }
                        }
                        else if (typeof this.$route.query.msitat !== "undefined") {
                            this.$router.push({
                                name: "AssessmentListPage",
                                query: this.$route.query
                            });
                        }
                        // --- "assessment" param ---
                        else if (typeof this.$route.query.assessment !== "undefined") {

                            this.$router.push({
                                name: 'SummaryPage',
                                query: this.$route.query
                            });

                        }
                        else {
                            let sessionStorageHomeRouteName = sessionStorage.getItem('smass-home-route');

                            if (sessionStorageHomeRouteName !== null) {
                                this.$router.push({name: sessionStorageHomeRouteName});
                            }
                            else if (this.getCurrentAppType === this.getAppTypes.PF_CHATBOT) {
                                this.$router.push({name: 'PF_ChatBotPage'});
                            }
                            else {
                                let sessionStorageHomeRouteName = sessionStorage.getItem("smass-home-route");
                                if (sessionStorageHomeRouteName !== null && sessionStorageHomeRouteName === "PF_ChatBotPage") {
                                    // PATHFINDER
                                    this.$router.push({name: 'PF_ChatBotPage'});
                                }
                                else {
                                    // PRO
                                    this.$router.push({name: 'HomePage'});
                                }
                            }
                        }
                    });
                    promiseLogin.catch((error) => {
                        console.log("we have a login error");
                        if (typeof error === "string") {
                            alert(error);
                        }
                        else if (typeof error.serverResponse !== "undefined"
                                && typeof error.serverResponse.data !== "undefined"
                                && typeof error.serverResponse.data.returnCode !== "undefined"
                                && error.serverResponse.data.returnCode === 102) {
                            this.error = this.text("api.login.badlogin");
                        }
                        else if (typeof error.serverResponse !== "undefined"
                                && typeof error.serverResponse.data !== "undefined"
                                && typeof error.serverResponse.data.returnCode !== "undefined"
                                && error.serverResponse.data.returnCode === 111) {
                            this.error = "Invalid login method";
                        }
                        else if (typeof error.serverResponse !== "undefined"
                            && typeof error.serverResponse.data !== "undefined"
                            && typeof error.serverResponse.data.returnCode !== "undefined"
                            && error.serverResponse.data.returnCode === 115) {
                            this.error = this.text("api.authentication.failed.block.ipAddress",  [error.serverResponse.data.timeout]);
                            let that = this;
                            setTimeout(function(){
                                that.error = '';
                            }, error.serverResponse.data.timeout*1000);

                        }
                    });
                }
            },


            changeLanguage(newLang) {
                this.$store.dispatch("TranslationStore/submitLanguageChange", newLang).then((response) => {
                    window.location.reload();
                });
            }
        },

        watch: {
            // Workaround for the use case when the user has entered the username and password
            // and then changes the theme. Without this code, when changing the theme while
            // the user has text in the input, makes the text be the incorrect color.
            getTheme(newVal, oldVal) {
                // We store the inputs value the user entered
                const username = this.username;
                const password = this.password;
                // We clear the form
                this.$refs.loginForm.reset();
                // On nextTick we set the values back to what the user entered before.
                this.$nextTick(() => {
                    this.username = username;
                    this.password = password;
                })

                // Firefox doesn't know how to apply this fix so we reload the page
                const browser = Bowser.getParser(window.navigator.userAgent);
                if (browser.isBrowser('Firefox') && username.length !== 0 && password.length !== 0) {
                    window.location.reload();
                }
            }
        }

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .error {
        background-color: transparent !important;
        color: $color-error;
    }
    .container.login-container {
        padding: 0;
        height: 100%;

        .layout {
            height: 100%;
            margin: 0;

            .flex.login-section {
                padding: 40px 0;
                background-color: $color-block-background;
                position: relative;

                .logo-language-selection {
                    display: flex;
                    justify-content: space-between;
                    padding-right: 15px;


                    .logo {
                        height: 64px;
                        max-width: 195px;
                    }

                    .input-group--select {
                        padding-top: 0;
                        width: 20%;

                        .input-group__input .icon {
                            display: none;
                        }

                    }

                }

                .powered-by{
                   // position: absolute;
                    bottom: 3%;
                    width: 75%;

                    svg {
                        width: 145px;
                        position: relative;
                        top: 8px;
                    }
                }

                .login-form {
                  //  position: absolute;
                  //  bottom: 25%;

                    form {

                        .login-input-field {
                            position: relative;
                            display: flex;

                            svg {
                                position: absolute;
                                top: 20px;
                                float: left;
                                width: 20px;
                            }

                            .input-group.input-group--text-field {
                                float: right;
                                width: 90%;

                            }
                            .text-field .v-text-field__slot input {
                                color: $color-headings-text !important;
                            }
                        }

                        button {
                            height: 45px;
                            border-radius: 5px;

                            .btn__content {
                                font-size: $font-size-medium;
                                font-family: $font-weight-light;
                            }
                        }
                    }

                }

                .toolbar {
                    background-color: transparent;
                }
            }

            .flex {
                padding: 0;

                .carousel {
                    height: 100%;

                    .jumbotron__content{

                        h4 {
                            padding-bottom: 8px;
                            margin-bottom: 15px;
                            position: relative;

                            &:after {
                                content:"";
                                background: $color-brand-primary;
                                position: absolute;
                                bottom: 0;
                                left: 37%;
                                height: 4px;
                                width: 25%;
                            }
                        }

                        span {
                            font-weight: $font-weight-light;
                        }
                    }
                }
            }

        }
    }


    @media only screen and (max-width: 600px) {

        .login-container {
            .layout .flex.login-section .login-form {

                width: 90%;
            }


        }

    }

    @media only screen and (min-width: 601px) and (max-width: 961px) {

        .login-container {
            .layout .flex.login-section .login-form {

                width: 90%;
            }

            .logo-language-selection img {
               // margin-right: 150px;
            }
        }
    }


    @media only screen and (min-width: 962px) and (max-width: 1300px) {

        .login-container {

            .layout .flex.login-section .login-form {
                width: 80%;
            }

            .jumbotron__content {

                h4 {
                    font-size: 2rem;
                    // SMASSDEV - 1119
                    // word-spacing: 0.16 * 2rem;
                    // line-height: 1.5 * 2rem;
                    // letter-spacing: 0.12 * 2rem;

                }

                span {
                    // SMASSDEV - 1119
                    font-size: $font-size-medium;
                    // word-spacing: $word-spacing-medium;
                    // line-height: $line-height-medium;
                    // letter-spacing: $letter-spacing-medium;

                }
            }

        }



        .container.login-container .layout .flex.login-section .powered-by svg {
            width: 125px;
            position: relative;
            top: 6px;
        }

    }

    @media only screen and (min-width: 1201px) and (max-width: 1699px) {

        .login-container {

            .layout .flex.login-section .login-form {
                width: 80%;
            }

            .jumbotron__content {

                h4 {
                    font-size: 2.25rem ;
                    // SMASSDEV - 1119
                    // word-spacing: 0.16 * 2.25rem;
                    // line-height: 1.5 * 2.25rem;
                    // letter-spacing: 0.12 * 2.25rem;

                }

                span {
                    // SMASSDEV - 1119
                    font-size: $font-size-medium;
                    // word-spacing: $word-spacing-medium;
                    // line-height: $line-height-medium;
                    // letter-spacing: $letter-spacing-medium;

                }
            }

            .logo-language-selection img {
                margin-right: 20px;
            }
        }
    }


    @media only screen and (min-width: 1700px) {

        .login-container {

            .layout .flex.login-section .login-form {
                width: 80%;
            }

            .jumbotron__content {

                h4 {
                    font-size: 2.625rem ;
                    // SMASSDEV - 1119
                    // word-spacing: 0.16 * 2.625rem;
                    // line-height: 1.5 * 2.625rem;
                    // letter-spacing: 0.12 * 2.625rem;

                }

                span {
                    // SMASSDEV - 1119
                    font-size: $font-size-big;
                    // word-spacing: $word-spacing-big;
                    // line-height: $line-height-big;
                    // letter-spacing: $letter-spacing-big;

                }
            }

            .logo-language-selection img {
                //margin-right: 150px;
            }
        }
    }

    .fade-enter-active, .fade-leave-active, .fade-leave-to {
        position: absolute;
    }

    @media only screen and (min-width: 1200px) and (max-width: 1700px) {
        .login-form .color-body {
            font-size: $font-size-small;
        }

    }


    @media only screen and (min-width: 800px) and (max-width: 1199px) {
        .login-form .color-body {
            font-size: $font-size-extra-small;
        }
    }


   @media only screen and (min-width: 960px) and (max-width: 1300px) {
       .login-container .logo-language-selection img {
           margin-right: 20px;
       }
   }

    .login-btn {
        background-color: $color-brand-primary;
        color: $color-on-primary;
    }

    @media only screen and (min-height: 500px) {
        .login-container {
            .login-form {
                position: absolute;
                bottom: 25%;
            }
        }

        .powered-by {
            position: absolute;
        }
    }

    @media only screen and (max-height: 499px) {
        .login-container {
            .layout {
                position: fixed;
                width: 100%;
                overflow-y: auto;
            }
        }

    }

    @media only screen and (min-width: 601px) {
        .login-section {
            padding-left: $spacing-xl !important;
        }
    }

    @media only screen and (max-width: 600px) {
        .login-section {
            padding-left: $spacing-m !important;
        }
    }

    @media only screen and (max-width: 400px) {
        .logo-language-selection img {
            margin-right: 5px;
        }
    }
    @media only screen and (min-width: 401px) {
        .logo-language-selection img {
            //margin-right: 150px;
        }
    }


</style>





// WEBPACK FOOTER //
// src/common/components/login/LoginPage.vue